var actions = {
  SET_CURRENT_TAB: 'SET_CURRENT_TAB',
  SET_VALUATION_REGISTRATION_RESPONSE: 'SET_VALUATION_REGISTRATION_RESPONSE',
  SET_LAYOUT_EXIST: 'SET_LAYOUT_EXIST'
};
export default actions;